import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AppState } from '@/redux/root';
import MfaActivateForm from './MfaActivateForm';
import MfaVerificationModal from '@/components/MfaVerificationModal';
import { usePrivy } from '@privy-io/react-auth';
import { Navigate } from 'react-router-dom';
import ROUTES from '@/routes/routes-enums';
import SplashScreen from '@/pages/auth/SplashScreen/SplashScreen';
import LoadingSpinner from '@/components/LoadingSpinner';
import { useAdminCheckQuery } from '@/redux/api/auth';
import VerticalLayout from '@/layouts/index';
import AccountLockedModal from './AccountLockedModal';

const MfAGuard = () => {
  const { mfaRequired, mfaContext, mfaSetupRequired, locked } = useSelector((state: AppState) => state.auth);
  const { authenticated } = usePrivy();

  const { isLoading: isAdminCheckLoading } = useAdminCheckQuery();

  if (locked === true) {
    return (
      <VerticalLayout>
        <AccountLockedModal />
      </VerticalLayout>
    );
  }

  if (!authenticated) {
    return <Navigate to={ROUTES.AUTHENTICATION} />;
  }

  // Show loading while checking admin status
  if (authenticated && isAdminCheckLoading) {
    return (
      <SplashScreen>
        <div className="text-center">
          <LoadingSpinner size="23" />
          <p className="mt-4 text-gray-600">Verifying admin access...</p>
        </div>
      </SplashScreen>
    );
  }

  if (mfaSetupRequired) {
    return (
      <VerticalLayout>
        <MfaActivateForm />
      </VerticalLayout>
    );
  }

  if (mfaRequired) {
    return (
      <VerticalLayout>
        <MfaVerificationModal context={mfaContext} />
      </VerticalLayout>
    );
  }

  return <Outlet />;
};

export default MfAGuard;
